<template>

  <div>
    <div>
      <vxe-form :data="toolbar.formData">
        <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
          <template #default="{ data }">
            <vxe-input v-model="data.searchKey" placeholder="请输入总部名称或编号" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="年份" field="year" :item-render="{}">
          <template #default="{ data }">
            <vxe-input v-model="data.year" type="year"
                       placeholder="全部" clearable style="width:100px"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="目标类型" field="GoalType" :item-render="{}">
          <template #default="{ data }">
            <vxe-select v-model="data.GoalType" placeholder="全部" clearable style="width:100px">
              <vxe-option value="1" label="C目标"></vxe-option>
              <vxe-option value="2" label="T1目标"></vxe-option>
              <vxe-option value="3" label="T2目标"></vxe-option>
              <vxe-option value="4" label="累计目标"></vxe-option>
            </vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item>
          <template #default>
            <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
            <vxe-button @click="clear">重置</vxe-button>
            <vxe-button status="success" @click="add">新增</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div style="overflow: hidden;height: 100%">
      <vxe-table
        stripe
        class="mytable-scrollbar"
        ref="table"
        :data="tableData"
        :height="tableHeight"
        show-overflow
        :row-config="{height: 36,isHover: true,isCurrent:true}"
      >
        <vxe-column type="seq" field="id" title="序号" width="55"></vxe-column>
        <vxe-column title="删除" width="60" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-trash-o" @click="removeRow(row)"></vxe-button>
          </template>
        </vxe-column>
        <vxe-column title="编辑" width="60" show-overflow>
          <template #default="{ row }">
            <vxe-button type="text" icon="fa fa-edit" @click="editRow(row)"></vxe-button>
          </template>
        </vxe-column>

        <vxe-column field="year" title="年份" width="68" sortable show-overflow></vxe-column>
        <vxe-column field="hqName" title="总部名称" width="120" sortable show-overflow></vxe-column>
        <vxe-column field="GoalTypeName" title="目标类型" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="m1" title="1月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m2" title="2月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m3" title="3月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m4" title="4月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m5" title="5月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m6" title="6月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m7" title="7月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m8" title="8月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m9" title="9月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m10" title="10月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m11" title="11月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="m12" title="12月" width="70" sortable show-overflow></vxe-column>
        <vxe-column field="yearTotal" title="目标合计" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="hqCode" title="总部编号" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="creatorName" title="创建人" width="100" sortable show-overflow></vxe-column>
        <vxe-column field="creationTime" title="创建时间" width="160" sortable show-overflow></vxe-column>
      </vxe-table>
    </div>
    <div>
      <vxe-pager
        background
        v-model:current-page="tablePager.currentPage"
        v-model:page-size="tablePager.pageSize"
        :total="tablePager.totalResult"
        @page-change="handlePageChange"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      </vxe-pager>
    </div>
  </div>
  <vxe-modal
    v-model="formInput.isShow"
    width="800"
    height="400"
    @close="findData"
    :title="formInput.title"
    show-zoom resize remember
  >
    <template #default>
      <div>
        <vxe-form
          :data="formInput.formData"
          :rules="formInput.formRules"
          ref="nForm"
        >
          <vxe-form-item title="年份" field="year" span="8" title-width="100px">
            <template #default="{data}">
              <vxe-input transfer v-model="data.year" type="year"
                         placeholder="请选择年份" clearable></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="总部名称" field="hqCode" span="8" title-width="100px">
            <template #default="{ data }">
              <vxe-select transfer v-model="data.hqCode" :options="formInput.hqOptions" placeholder="">
              </vxe-select>
            </template>
          </vxe-form-item>

          <vxe-form-item title="目标类型" field="GoalType" span="8" title-width="100px">
            <template #default="{data}">
              <vxe-select v-model="data.GoalType" placeholder="全部" clearable>
                <vxe-option value="1" label="C目标"></vxe-option>
                <vxe-option value="2" label="T1目标"></vxe-option>
                <vxe-option value="3" label="T2目标"></vxe-option>
                <vxe-option value="4" label="累计目标"></vxe-option>
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="目标分解" span="24" title-align="left" title-width="200px"
                         :title-prefix="{icon: 'fa fa-list'}"></vxe-form-item>
          <vxe-form-item title="1月目标" field="m1" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m1" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="2月目标" field="m2" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m2" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="3月目标" field="m3" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m3" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="4月目标" field="m4" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m4" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="5月目标" field="m5" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m5" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="6月目标" field="m6" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m6" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="7月目标" field="m7" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m7" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="8月目标" field="m8" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m8" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="9月目标" field="m9" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m9" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="10月目标" field="m10" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m10" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="11月目标" field="m11" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m11" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="12月目标" field="m12" span="6" title-width="100px">
            <template #default="{data}">
              <vxe-input v-model="data.m12" type="number" placeholder="">
              </vxe-input>
            </template>
          </vxe-form-item>


          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button @click="save" icon="fa fa-save" status="success">保存
              </vxe-button>

            </template>
          </vxe-form-item>
        </vxe-form>
      </div>

    </template>
  </vxe-modal>


</template>

<script>

import Qs from 'qs'
import {reactive} from 'vue';
import {VXETable} from 'vxe-table'


export default {
  name: "YearGoals",
  components: {},
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: '',
        year: '',
        GoalType: ''
      }
    })


    const formInput = reactive({
      isShow: false,
      editType: '1',
      title: '新增年度目标',
      hqOptions: [],
      formData: {
        id: '',
        hqCode: '',
        year: '',
        GoalType: '',
        m1: 0,
        m2: 0,
        m3: 0,
        m4: 0,
        m5: 0,
        m6: 0,
        m7: 0,
        m8: 0,
        m9: 0,
        m10: 0,
        m11: 0,
        m12: 0,
        creator: '',
        modifier: ''

      }, formRules: {
        hqCode: [
          {required: true, message: '总部不能为空'},
        ],
        year: [
          {required: true, message: '年份不能为空'}],
        GoalType: [
          {required: true, message: '目标类型不能为空'}],
      }
    })

    return {
      tableData: null,
      tablePager,
      toolbar,
      formInput,
      pageHeight,
      tableHeight: 0
    }
  },
  methods: {
    add() {
      this.bindHQ();
      this.formInput.isShow = true;
      this.formInput.editType = '1';
      this.formInput.title = '新增年度目标';
      this.formInput.formData = {
        id: '',
        hqCode: '',
        year: '',
        GoalType: '',
        m1: 0,
        m2: 0,
        m3: 0,
        m4: 0,
        m5: 0,
        m6: 0,
        m7: 0,
        m8: 0,
        m9: 0,
        m10: 0,
        m11: 0,
        m12: 0,
        creator: this.getUserId,
        modifier: this.getUserId
      };
    },
    editRow(row) {
      const params = {
        'uid': this.getUserId,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.id]
      };
      this.formInput.isShow = true;

      this.$api.digitalDictManageAPI.getYearGoalsOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.isShow = true;
          this.formInput.formData.id = res.data.Data.dataTable[0].id;
          this.formInput.formData.hqCode = res.data.Data.dataTable[0].hqCode;
          this.formInput.formData.GoalType = res.data.Data.dataTable[0].GoalType;
          this.formInput.formData.year = res.data.Data.dataTable[0].year;
          this.formInput.formData.m1 = res.data.Data.dataTable[0].m1;
          this.formInput.formData.m2 = res.data.Data.dataTable[0].m2;
          this.formInput.formData.m3 = res.data.Data.dataTable[0].m3;
          this.formInput.formData.m4 = res.data.Data.dataTable[0].m4;
          this.formInput.formData.m5 = res.data.Data.dataTable[0].m5;
          this.formInput.formData.m6 = res.data.Data.dataTable[0].m6;
          this.formInput.formData.m7 = res.data.Data.dataTable[0].m7;
          this.formInput.formData.m8 = res.data.Data.dataTable[0].m8;
          this.formInput.formData.m9 = res.data.Data.dataTable[0].m9;
          this.formInput.formData.m10 = res.data.Data.dataTable[0].m10;
          this.formInput.formData.m11 = res.data.Data.dataTable[0].m11;
          this.formInput.formData.m12 = res.data.Data.dataTable[0].m12;

          this.formInput.title = '编辑年度目标'
          this.formInput.editType = '2';//更新
        })
        .catch(error => {
          console.log(error);

        })
    },
    async removeRow(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        this.$api.digitalDictManageAPI.deleteYearGoals(Qs.stringify({"hqId": row.id}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});
            $grid.remove(row);
          })
          .catch(error => {
            console.log(error);
          })
      }

    },
    async save() {
      const $rForm = this.$refs.nForm;
      const formErrMap = await $rForm.validate();
      if (formErrMap) {
        return;
      }
      let params = this.formInput.formData;
      params.m1 ??= 0
      params.m2 ??= 0
      params.m3 ??= 0
      params.m4 ??= 0
      params.m5 ??= 0
      params.m6 ??= 0
      params.m7 ??= 0
      params.m8 ??= 0
      params.m9 ??= 0
      params.m10 ??= 0
      params.m11 ??= 0
      params.m12 ??= 0

      //新增
      if (this.formInput.editType === '1') {
        this.$api.digitalDictManageAPI.addYearGoals(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.alert({content: error, status: 'error'});
            console.log(error);
          });
      } else if (this.formInput.editType === '2') { //更新
        this.$api.digitalDictManageAPI.updateYearGoals(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey, this.toolbar.formData.year, this.toolbar.formData.GoalType]
      };
      this.$api.digitalDictManageAPI.getYearGoalsList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});

            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);

        })
        .catch(error => {
          console.log(error);

        })
    },
    bindHQ() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 50,
        'searchKey': ['']
      };
      this.$api.digitalDictManageAPI.getHeadquarterList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            console.log(res.data.Message)
            return;
          }
          // console.log(res.data.Data);
          this.formInput.hqOptions = []
          for (const item of res.data.Data.dataTable) {
            this.formInput.hqOptions.push({value: item.hqCode, label: item.hqName});
          }
        })
        .catch(error => {
          console.log(error);

        })
    },

    handlePageChange() {
      this.findData();
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    clear() {
      this.toolbar.formData.searchKey = '';
      this.toolbar.formData.year = '';
      this.toolbar.formData.GoalType = '';
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
  },
  mounted() {
    this.bindHQ();
    this.findData();
    this.formInput.formData.creator = this.getUserId;
    this.formInput.formData.modifier = this.getUserId;
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getJobZb() {
      return this.$store.state.jobZb;
    },
    getJobName() {
      return this.$store.state.jobName;
    },
    getUserEmail() {
      return this.$store.state.email;
    },
    getUserId() {
      return this.$store.state.userID;
    }
  }
}

</script>


<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
